import React, {Fragment, ReactElement, useEffect, useRef} from "react"
import {useGeographic} from 'ol/proj.js'
import {useStore} from "@ui/stores"
import Popup from "./Popup"

const Map = (): ReactElement => {
  const store = useStore()
  const mapElement = useRef<HTMLDivElement>(null)

  useEffect(() => {
    useGeographic()
    store.init().then(() => store.map.setTarget(mapElement.current || undefined))
  }, [])

  return (
    <Fragment>
      <div className="map-element" ref={mapElement}/>
      <Popup />
    </Fragment>
  )
}

export default Map
